import { getLeaves } from '../../../pages/Analytics/queries/getLeaves';
import { supabase } from '../../../services/supabase';
import { TaggregatedCheckIns, Tleaves } from '../../../types/analyticsTypes';

export const getGranularCheckInData = async (
  startDate: string,
  endDate: string,
  team: string,
  teamId: string,
  employeeId?: string,
): Promise<{
  aggregatedCheckIns: TaggregatedCheckIns[];
  leaves: Tleaves[];
}> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data, error: aggregatedCheckInsError } = await supabase.rpc(
    'get_granular_check_in_data',
    {
      start_date: startDate,
      end_date: endDate,
      team_id: teamId,
      ...(employeeId && { employeeid: employeeId }),
    },
  );
  if (startDate > endDate) {
    return {
      aggregatedCheckIns: data as TaggregatedCheckIns[],
      leaves: [],
    };
  }
  const { leaves, error: leavesError } = await getLeaves(
    startDate,
    endDate,
    team,
    employeeId,
  );

  if (leavesError || aggregatedCheckInsError) {
    throw new Error('Error fetching data');
  }
  return {
    aggregatedCheckIns: data as TaggregatedCheckIns[],
    leaves,
  };
};
